export enum DecisionLevel {
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error',
}
